import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHouseComment = async (houseId) => {
  return await request.get(
    `HousingStock/house/${houseId}/comment`,
    {},
    'При загрузке комментария произошла ошибка',
    {}
  );
};

const useHouseComment = (houseId, options = {}) =>
  useQuery(getQueryKeys.houseComment(houseId), () => getHouseComment(houseId), {
    placeholderData: {},
    enabled: Boolean(houseId),
    ...options,
  });

export default useHouseComment;
